export const LOGIN_ENDPOINT = {
  method: 'POST',
  url: '/v1/login',
};
